import { InfoCard } from "../../UnitPanel/components/common/InfoCard"
import { EditableNozzleTable } from "./NozzleTable"
import { cellToNodeState } from "@/components/FlowSheetEditor/services/storage"
import { useState } from "react"
import { NodeState } from "@/components/FlowSheetEditor/services/modal"
import { NozzleType } from "@/types/common"
import { Node } from "@antv/x6"
import { useGraphInstance } from "@antv/xflow"

interface DefaultNozzlesProps {
  node: Node
}

function getDefaultNozzles(nodeState: NodeState) {
  return nodeState.nozzles.filter(item => item.type === NozzleType.FlowNozzle)
}

export function DefaultNozzles(props: DefaultNozzlesProps) {
  const {node} = props;
  const nodeState = cellToNodeState(node);
  const graph = useGraphInstance()
  const [nozzles, setNozzles] = useState(getDefaultNozzles(nodeState))

  const onChange = () => {
    const newNode = graph?.getCellById(nodeState.id)
    if (newNode) {
      const newState = cellToNodeState(newNode as Node)
      setNozzles(getDefaultNozzles(newState))
    }
  }
  
  return <InfoCard title={'Default Nozzles'}>
    <EditableNozzleTable nozzles={nozzles} node={node} onChange={onChange} deleteAble={false} />
  </InfoCard>
}